import http from 'plugins/axios';

export default {
  getSwitchList() {
    return http.get({
      url: '/admin/switch/list'
    });
  },
  updateSwitchStatus({ coinType, switchType, status }) {
    return http.post({
      url: `/admin/switch/update/${coinType}/${switchType}/${status}`
    });
  },
  updateBatchWithdrawSize({ coinType, size }) {
    return http.post({
      url: '/admin/switch/update/batchWithdrawSize',
      data: {
        coinType,
        size
      },
      dataType: 'form'
    });
  },
  updateGasPrice({ coinType, price }) {
    return http.post({
      url: '/admin/switch/update/gasPrice',
      data: {
        coinType,
        price
      },
      dataType: 'form'
    });
  },
  updateToColdGasPrice({ coinType, price }) {
    return http.post({
      url: '/admin/switch/update/toColdGasPrice',
      data: {
        coinType,
        price
      },
      dataType: 'form'
    });
  },

  updateGasLimitChange({ coinType, gasLimit }) {
    return http.post({
      url: '/admin/switch/update/gasLimit',
      data: {
        coinType,
        gasLimit
      },
      dataType: 'form'
    });
  },

  updateToColdGasLimitChange({ coinType, gasLimit }) {
    return http.post({
      url: 'admin/switch/update/toColdGasLimit',
      data: {
        coinType,
        gasLimit
      },
      dataType: 'form'
    });
  },
  getBatchSwitchList() {
    return http.get({
      url: '/admin/switch/batch/list'
    });
  },
  getEntrySwitchList() {
    return http.get({
      url: '/admin/switch/entry/list'
    });
  },
  updateBatchSwitchStatus({ name, switchType, status }) {
    return http.post({
      url: `/admin/switch/batch/update/${name}/${switchType}/${status}`
    });
  },
  updateJobBatchSize({ name, size }) {
    return http.post({
      url: `/admin/switch/batch/update/batchSize/${name}/${size}`
    });
  },
  deleteBatchJob({ name }) {
    return http.post({
      url: `/admin/switch/batch/delete/${name}`
    });
  },

  /** 通过获取开关配置信息*/
  findSwitchConfigInfoByCoinType(data) {
    return http.get({
      url: '/admin/switch/infoByCoinType',
      data
    });
  },

  /** 通过jobName 获取批量开关的配置信息*/
  findBatchSwitchInfoByJobName(data) {
    return http.get({
      url: '/admin/switch/batchInfoByJobName',
      data
    });
  },

  getCancelTradeList() {
    return http.get({
      url: '/admin/switch/cancelTrade/list'
    });
  },

  getServiceChargeList(data) {
    return http.get({
      url: '/admin/serviceCharge/coin/list',
      data
    });
  },

  getSwitchInfoByCoinType(data) {
    return http.get({
      url: '/admin/serviceCharge/infoByCoinType',
      data
    });
  },

  editGasPrice(data) {
    return http.post({
      url: '/admin/serviceCharge/gasPrice',
      data,
      dataType: 'form'
    });
  },

  editToColdGasPrice(data) {
    return http.post({
      url: '/admin/serviceCharge/toColdGasPrice',
      data,
      dataType: 'form'
    });
  }
};
